import {connect} from '@modifi/redux'
import {aPush, generatePath} from '@modifi/router'

import SummaryPageFooter, {SummaryPageFooterProps} from './SummaryPageFooter'
import {getRouteConfigForSection} from '../../../../utils/route-configs'
import {getNextSection} from '../../../../layouts/page-layout/components/sub-section-layout/constants'

const mapStateToProps = (
  state: Record<string, any>,
  ownProps: {sectionName: string}
): Pick<SummaryPageFooterProps, 'continueRoute' | 'isLastVisibleSection'> => {
  const nextSection = getNextSection(state, ownProps.sectionName)
  return {
    continueRoute: nextSection ? generatePath(getRouteConfigForSection(nextSection)!) : '',
    // no further visible section/sub-section follows the current one
    isLastVisibleSection: !nextSection,
  }
}

const mapDispatchToProps = {
  redirect: aPush,
}

export default connect(mapStateToProps, mapDispatchToProps)(SummaryPageFooter)
